import { msg } from '@lingui/core/macro';
import type { MessageDescriptor } from 'shared/i18n';
import { Role } from 'shared/types/role';

export const ROLE_LABELS: Record<Role, MessageDescriptor> = {
  STAFF: msg`Игрок`,
  CAPTAIN: msg`Капитан`,
  FAN: msg`Фанат`,
};

export function getRoleLabel(role?: string | null): MessageDescriptor | undefined {
  return role && role in ROLE_LABELS ? ROLE_LABELS[role as Role] : undefined;
}
